import React, { FC } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import StyledIcon from "../StyledIcon";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";

export const AlertBox: FC<{
  theme: "success" | "warning" | "danger";
  body: any;
  icon?: React.ReactElement;
  hideBox?: (arg?: any) => any;
}> = ({ body, icon, theme, hideBox }) => {
  return (
    <>
      <View style={styles.main}>
        <View style={[styles.container, styles[`container_${theme}`]]}>
          {icon ? (
            icon
          ) : (
            <StyledIcon
              iconName="exclamation"
              iconColor={Colors.whiteColor}
              iconLibrary="MaterialCommunityIcons"
              fillColor={Colors[`${theme}Text`]}
            />
          )}
          <View style={styles.content}>
            <Text style={styles.body}>{body}</Text>
          </View>
          {!!hideBox && (
            <TouchableOpacity
              onPressIn={hideBox}
              style={styles.closeButtonContainer}
            >
              <StyledIcon
                size={16}
                iconName="md-close-circle"
                iconColor={Colors[`${theme}Text`]}
                iconOnly
              />
            </TouchableOpacity>
          )}
        </View>
      </View>
    </>
  );
};

const styles: any = StyleSheet.create({
  main: {},
  container: {
    borderRadius: 6,
    borderWidth: 1,
    borderStyle: "solid",
    flexDirection: "row",
    padding: 12,
    alignItems: "center",
  },
  container_success: {
    borderColor: Colors.successText + "1A",
    backgroundColor: Colors.successBackground,
  },
  container_warning: {
    borderColor: Colors.warningText + "1A",
    backgroundColor: Colors.warningBackground,
  },
  container_danger: {
    borderColor: Colors.dangerText + "1A",
    backgroundColor: Colors.dangerBackground,
  },
  content: {
    flex: 1,
    flexGrow: 1,
    flexDirection: "column",
    paddingLeft: 8,
  },
  heading: {
    ...FontStyles.semibold,
    ...FontStyles.size14,
    ...FontStyles.lh18,
    ...FontStyles.dark,
  },
  body: {
    ...FontStyles.normal,
    ...FontStyles.size14,
    ...FontStyles.lh22,
    ...FontStyles.dark,
  },
  closeButtonContainer: {
    padding: 4,
  },
});
